define(function() {
  const IpsModelCollection = require('civicsBase/ipsModelCollection');

  return IpsModelCollection.extend({
    url: function() {
      return '/delegate/civics-api/api/gis/sync/integration/ipsfeatures/';
    },
  });
});
